var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.062A3.195 3.195 0 0 1 .52 6.577a3.193 3.193 0 0 1 2.972-3.4.228.228 0 0 0 .21-.126 3.868 3.868 0 0 1 7.508.91.246.246 0 0 0 .173.2A2.73 2.73 0 0 1 12 9.249M8.108 6.946 5.89 8.055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5a1 1 0 1 0 2 0 1 1 0 1 0-2 0m-4 2a1 1 0 1 0 2 0 1 1 0 1 0-2 0m4 2a1 1 0 1 0 2 0 1 1 0 1 0-2 0M5.89 8.945l2.218 1.109"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudShare);
export default __webpack_public_path__ + "static/media/Cloud-Share.6c9ac0e45db05631716cddc8a5685ef5.svg";
export { ForwardRef as ReactComponent };